import { ScreenOrientation } from '@gongxigames/framework/core';

export interface IScrollToFullscreen {
    isFullscreen(orientation: ScreenOrientation): boolean;

    show(currentOrientation: ScreenOrientation): void;

    hide(currentOrientation: ScreenOrientation): void;

    destroy(): void;
}
